/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import {
  IInboundTaskItem,
  IInboundTaskProcessedItem,
  InboundTaskItemState,
  ProductDetail,
} from 'commons/types';
import { ReducerKeys } from 'redux-stores/enums/reducerKey.enum';

const initialState: InboundTaskItemState = {
  assignedInboundTaskItems: [],
  currentReceiveItemIndex: -1,
  inboundTaskReceiveItem: null,
  binRecommendationInfo: [
    {
      bin: '-',
      bin_type: '-',
      inventory_number: '-',
      quantity: 0,
    } as ProductDetail,
  ],
};

const inboundTaskItemSlice = createSlice({
  name: ReducerKeys.InboundTaskItem,
  initialState,
  reducers: {
    setAssignedInboundTaskItem(
      state: InboundTaskItemState,
      action: { type: string; payload: IInboundTaskItem[] },
    ) {
      state.assignedInboundTaskItems = action.payload;
    },
    setInboundTaskReceiveItem(
      state: InboundTaskItemState,
      action: { type: string; payload: IInboundTaskItem | null },
    ) {
      state.inboundTaskReceiveItem = action.payload;
    },
    setInboundTaskcurrentReceiveItemIndex(
      state: InboundTaskItemState,
      action: { type: string; payload: number },
    ) {
      state.currentReceiveItemIndex = action.payload;
    },
    setInboundTaskBinRecommendationInfo(
      state: InboundTaskItemState,
      action: { type: string; payload: ProductDetail[] },
    ) {
      state.binRecommendationInfo = action.payload;
    },
    setAssignedInboundTaskReceiveActual(
      state: InboundTaskItemState,
      action: {
        type: string;
        payload: {
          isRemove: boolean;
          item: IInboundTaskProcessedItem;
        };
      },
    ) {
      const { isRemove, item } = action.payload;
      const itemIdx = state.currentReceiveItemIndex;
      if (state.assignedInboundTaskItems[itemIdx]) {
        if (isRemove) {
          // pop the receive actual value
          state.assignedInboundTaskItems[itemIdx].receive_actual =
            state.assignedInboundTaskItems[itemIdx].receive_actual.filter(
              (actual) =>
                item.bin !== actual.bin ||
                item.inventory_number !== actual.inventory_number,
            );
        } else {
          // replace/add the value
          const isExist = state.assignedInboundTaskItems[
            itemIdx
          ].receive_actual.find(
            (actual) =>
              item.bin === actual.bin &&
              item.inventory_number === actual.inventory_number,
          );
          if (isExist) {
            state.assignedInboundTaskItems[itemIdx].receive_actual =
              state.assignedInboundTaskItems[itemIdx].receive_actual.map(
                (actual) =>
                  item.bin === actual.bin &&
                  item.inventory_number === actual.inventory_number
                    ? item
                    : actual,
              );
          } else {
            state.assignedInboundTaskItems[itemIdx].receive_actual.push(item);
          }
        }
      }
    },
    setInboundTaskReceiveItemActual(
      state: InboundTaskItemState,
      action: {
        type: string;
        payload: {
          isRemove: boolean;
          item: IInboundTaskProcessedItem;
        };
      },
    ) {
      const { isRemove, item } = action.payload;
      if (state.inboundTaskReceiveItem) {
        if (isRemove) {
          // pop the receive actual value
          state.inboundTaskReceiveItem.receive_actual =
            state.inboundTaskReceiveItem.receive_actual.filter(
              (actual) =>
                item.bin !== actual.bin ||
                item.inventory_number !== actual.inventory_number,
            );
        } else {
          // replace/add the value
          const isExist = state.inboundTaskReceiveItem.receive_actual.find(
            (actual) =>
              item.bin === actual.bin &&
              item.inventory_number === actual.inventory_number,
          );
          if (isExist) {
            state.inboundTaskReceiveItem.receive_actual =
              state.inboundTaskReceiveItem.receive_actual.map((actual) =>
                item.bin === actual.bin &&
                item.inventory_number === actual.inventory_number
                  ? item
                  : actual,
              );
          } else {
            state.inboundTaskReceiveItem.receive_actual.push(item);
          }
        }
      }
    },
  },
});

export const {
  setAssignedInboundTaskItem,
  setInboundTaskcurrentReceiveItemIndex,
  setInboundTaskReceiveItem,
  setAssignedInboundTaskReceiveActual,
  setInboundTaskReceiveItemActual,
  setInboundTaskBinRecommendationInfo,
} = inboundTaskItemSlice.actions;

export default inboundTaskItemSlice.reducer;
